<template>
    <div class="animated fadeIn">
        <table class="kgr-table kgr-table--striped kgr-table--block data-table table-groups printable">
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Ort') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Bereich') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('Feld') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="row in createRows()">
                    <tr
                        v-if="row.location.isEditable && row.area.isEditable && row.field.isEditable"
                        :key="row.key"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <template v-if="row.showLocation">
                                <a
                                    v-if="row.location.isEditable"
                                    :href="urlForEdit(row.location)"
                                    class="kgr-link"
                                >
                                    {{ row.location.name }}
                                </a>
                                <div v-else>
                                    {{ row.location.name }}
                                </div>
                            </template>
                        </td>
                        <td class="kgr-table__cell">
                            <template v-if="row.showArea">
                                <a
                                    v-if="row.location.isEditable && row.area.isEditable"
                                    :href="urlForEdit(row.area)"
                                    class="kgr-link"
                                >
                                    {{ row.area.name }}
                                </a>
                                <div v-else>
                                    {{ row.area.name }}
                                </div>
                            </template>
                        </td>
                        <td class="kgr-table__cell">
                            <a
                                v-if="row.location.isEditable && row.area.isEditable && row.field.isEditable"
                                :href="urlForEdit(row.field)"
                                class="kgr-link"
                            >
                                {{ row.field.name }}
                            </a>
                            <div v-else>
                                {{ row.field.name }}
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import LocationImageUrlMixin from './LocationImageUrlMixin';

export default {
    name: 'KgrLocationsTable',
    mixins: [LocationImageUrlMixin],
    props: {
        locations: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
            default: null,
        },
    },
    methods: {
        createRows() {
            return this.locations.filter((location) => !location.isArchived).flatMap((location) => {
                return location.areas.filter((area) => !area.isArchived).flatMap((area, areaIndex) => {
                    return area.fields.filter((field) => !field.isArchived).flatMap((field, fieldIndex) => {
                        const row = {
                            key: [location.id, area.id, field.id].join('-'),
                            location,
                            area,
                            field,
                            showLocation: areaIndex === 0 && fieldIndex === 0,
                            showArea: fieldIndex === 0,
                        };
                        return this.rowMatchesFilter(row) ? [row] : [];
                    });
                });
            });
        },
        rowMatchesFilter(row) {
            if (this.filter === null || this.filter === '') {
                return true;
            }

            const filter = this.filter.toLowerCase().trim();

            if (row.location.name.toLowerCase().includes(filter)) {
                return true;
            }

            if (row.area.name.toLowerCase().includes(filter)) {
                return true;
            }

            if (row.field.name.toLowerCase().includes(filter)) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
